import * as XLSX from 'xlsx'

// Z80 Phase 1 Step 4: export helpers. Two shapes, matching the two existing export
// conventions already in this codebase (cdsExporter.ts's XLSX.writeFile for internal/full
// exports, naFileExporter.ts's Blob+anchor download for plain CSV) rather than inventing a
// third pattern.

function csvEscape(v: unknown): string {
  const s = v === null || v === undefined ? '' : String(v)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export function downloadBlob(filename: string, content: BlobPart, type: string) {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url; a.download = filename; a.click()
  URL.revokeObjectURL(url)
}

export interface ExportLineRow {
  chargeCode: string
  description: string
  unit: string
  containerType: string
  unitPrice: number
  unitCost: number | null
  minCharge: number | null
  maxCharge: number | null
  notes: string
}

// Customer-facing CSV -- public fields only (no cost, no internal notes), same
// "text/csv;charset=utf-8;" + Blob+anchor download as naFileExporter.ts's downloadNaFileCsv.
export function downloadRateCardCsv(filename: string, rateCardName: string, lines: ExportLineRow[]) {
  const headers = ['Charge Code', 'Description', 'Unit', 'Container Type', 'Unit Price']
  const rows = lines.map(l => [l.chargeCode, l.description, l.unit, l.containerType, l.unitPrice.toFixed(2)])
  const csv = [headers, ...rows].map(r => r.map(csvEscape).join(',')).join('\r\n')
  void rateCardName
  downloadBlob(filename, csv, 'text/csv;charset=utf-8;')
}

// Internal XLSX -- every field including unit_cost, matching cdsExporter.ts's
// XLSX.utils.json_to_sheet + XLSX.writeFile pattern. ADMIN-only page, so no extra gating here.
export function downloadRateCardsXlsx(filename: string, sheets: { sheetName: string; lines: ExportLineRow[] }[]) {
  const wb = XLSX.utils.book_new()
  for (const { sheetName, lines } of sheets) {
    const rows = lines.map(l => ({
      'Charge Code': l.chargeCode, 'Description': l.description, 'Unit': l.unit, 'Container Type': l.containerType,
      'Unit Price': l.unitPrice, 'Unit Cost': l.unitCost ?? '', 'Min Charge': l.minCharge ?? '', 'Max Charge': l.maxCharge ?? '', 'Notes': l.notes,
    }))
    const ws = XLSX.utils.json_to_sheet(rows)
    // Sheet names are capped at 31 chars and can't contain []:*?/\\ -- Excel hard limits, not
    // this app's own rule.
    const safeName = sheetName.replace(/[[\]:*?/\\]/g, ' ').slice(0, 31) || 'Sheet'
    XLSX.utils.book_append_sheet(wb, ws, safeName)
  }
  XLSX.writeFile(wb, filename)
}
